'use strict'
export default class Post {
    constructor(
        _id_user='',
        description='',
        visibility='',
        files=[]
    ) {
        this._id_user = _id_user
        this.description = description
        this.visibility = visibility
        this.files = files
    }

}